import { EntityService, GlobalService } from "app/core/services";
import { Image } from "../model/image";
import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { UploadImageRequest } from "../model/requests/UploadImageRequest";
import { SelectList } from "../model/selectList";
import { ImageAccessUrlViewModel } from "../model/ImageAccessUrlViewModel";
import { map } from "rxjs/operators";

@Injectable()
export class ImageService {
    constructor(
        private http: GlobalService,
        private entityService: EntityService
    ) { }



    search(number: number, entityId: number): Observable<Image[]> {
        const url = `Images/search/${number}/${entityId}`;
        return this.http
            .get(url)
            .map((res) => this.entityService.extractData<Image[]>(res))
            .map((data) => {
                return data.map((dataItem) => {
                    const deductible = new Image();
                    return this.entityService.copy(dataItem, deductible);
                });
            });
    }

    getTypes(entityId: number): Observable<SelectList[]> {
        const url = `Images/TypesDocument/${entityId}`;

        return this.http
            .get(url)
            .map(res => this.entityService.extractData<any[]>(res))
            .map(data => {
                return data.map(item => {
                    const selectItem = new SelectList();
                    selectItem.id = item.id;
                    selectItem.description = item.descripcion;
                    return selectItem;
                });
            });
    }

    Add(entity: UploadImageRequest, file: File): Observable<boolean> {

        const url = `Images/add`;

        const formData: FormData = new FormData();
        formData.append("Id", "-100");
        formData.append("Number", entity.number.toString());
        formData.append("EntityId", entity.entityId.toString());
        formData.append("TypeDocument", entity.typeDocument || "");
        formData.append("file", file, file.name);
        formData.append("TypeDocumentId", entity.typeDocumentId.toString());
        const headers = new Headers();

        return this.http.postFile(url, formData, headers)
            .map(() => true)
            .catch(err => {
                console.error("Error uploading file:", err);
                return Observable.of(false);
            });

    }

    GetImageAccessUrl(id: number): Observable<ImageAccessUrlViewModel> {

        const url = `Images/${id}/access-url`;

        return this.http
            .get(url)
            .map(res => this.entityService.extractData<any>(res))
            .map(data => {
                const result = new ImageAccessUrlViewModel();
                result.url = data.url;
                result.expiresOn = data.expiresOn;
                result.isPrivate = data.isPrivate;
                return result;
            });
    }


}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/shared-model/services/images.service.ts